import React, { useEffect, useState } from 'react';
import { CircularProgress, Alert } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { ReportLayout, exportToCsv, useReportDates } from './ReportLayout';
import { reportsApi } from '../../api/reports';

const columns: GridColDef[] = [
  { field: 'worker_name', headerName: 'Worker', flex: 1, minWidth: 150 },
  { field: 'base_rate', headerName: 'Base Rate', type: 'number', width: 100 },
  { field: 'total_assigned', headerName: 'Assigned', type: 'number', width: 100 },
  { field: 'total_received', headerName: 'Received', type: 'number', width: 100 },
  { field: 'total_defects', headerName: 'Defects', type: 'number', width: 90 },
  { field: 'defect_rate', headerName: 'Defect %', type: 'number', width: 100 },
  { field: 'earnings', headerName: 'Earnings', type: 'number', width: 110 },
  { field: 'designs_count', headerName: 'Designs', type: 'number', width: 90 },
  { field: 'avg_daily_output', headerName: 'Avg Daily Output', type: 'number', width: 140 },
];

export default function PressProductivityReport() {
  const { startDate, endDate, setStartDate, setEndDate } = useReportDates();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchData = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await reportsApi.getPressProductivity({
        startDate: startDate?.toISOString(),
        endDate: endDate?.toISOString(),
      });
      setData(res.data);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to load report');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  return (
    <ReportLayout
      title="Press Station Productivity Report"
      startDate={startDate}
      endDate={endDate}
      onStartDateChange={setStartDate}
      onEndDateChange={setEndDate}
      onExport={() => exportToCsv('press-productivity.csv', data)}
      loading={loading}
    >
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? (
        <CircularProgress />
      ) : (
        <DataGrid
          rows={data}
          columns={columns}
          getRowId={(row) => row.worker_id}
          autoHeight
          disableRowSelectionOnClick
          initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
          pageSizeOptions={[25, 50]}
        />
      )}
    </ReportLayout>
  );
}
